import script from "./AddContactBasic.vue?vue&type=script&setup=true&lang=js"
export * from "./AddContactBasic.vue?vue&type=script&setup=true&lang=js"

import "./AddContactBasic.vue?vue&type=style&index=0&id=d95066c2&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d95066c2"]])

export default __exports__